import React, { Dispatch, FC } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Action } from 'redux';

import { logout as serviceLogout } from '../../lib/store/common-actions';

import IconBack from '../../assets/img/icon-arrow_back.svg';
import IconCloseWhite from '../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../hooks';
import { UI_ROUTES } from '../../util/routes';
import { ClickableImage, HeaderLogo } from '../index';

import styles from './LogoAndCloseButton.module.scss';

type Props = {
  onBackBtnPress?: Function;
  displayBackButton: boolean;
  displayCloseButton: boolean;
  isLayout?: boolean;
} & ReduxProps

const LogoAndCloseButton: FC<Props> = (props: Props): JSX.Element => {
  const { onBackBtnPress, displayCloseButton, displayBackButton, isLayout, logout } = props;
  const history = useHistory();
  const isMobile = useIsMobile();

  const handleLogout = () => {
    logout();
    history.push(UI_ROUTES.signUp);
  };

  if (isMobile) {
    return displayBackButton ? (
      <ClickableImage
        alt=""
        src={IconBack}
        className={styles.backIcon}
        onClick={() => (onBackBtnPress ? onBackBtnPress() : history.goBack())}
      />
    ) : <></>;
  }

  return (
    <>
      <HeaderLogo className={styles.logoCapital} isLayout={isLayout} />
      {displayCloseButton && (
        <ClickableImage
          alt=""
          src={IconCloseWhite}
          className={styles.closeIcon}
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        />
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  logout: () => dispatch(serviceLogout()),
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(LogoAndCloseButton);
